// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1B1gL","paramInput":"JobSimulator_paramInput__k0RKM","input":"JobSimulator_input__2vkxu"};